import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import { COOKIE_CONSENT_KEY } from '@/utils/cookieUtils';
import './CookieConsent.css';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if consent has already been given
    const hasConsent = Cookies.get(COOKIE_CONSENT_KEY) === 'accepted';
    setIsVisible(!hasConsent);
  }, []);

  const handleAccept = () => {
    setIsVisible(false);
    // Save the consent in cookies with 365 days expiry
    Cookies.set(COOKIE_CONSENT_KEY, 'accepted', { expires: 365 });
  };

  if (!isVisible) return null;

  return (
    <div className="cookie-consent-banner">
      <p>
        We care about your data, and we'd use cookies only to improve your experience. By using this website, you accept our{' '}
        <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">
          Cookies Policy
        </a>.
      </p>
      <button className="accept-button" onClick={handleAccept}>
        Accept
      </button>
    </div>
  );
};

export default CookieConsent;